import React, {Component} from 'react';
import axios from 'axios';
import './Signup2.css';
class Signup2 extends React.Component {

constructor(){
    super();
}
 

  render() {
    return <div>

                <div className="row  ">


                  <div className=" p-5 center-space">
                    <div className="text-center">
                      <a className="" href=""> <img src="/assets/images/logo/logo.jpg" alt="" title="" className="img-fluid" /> </a>
                    </div>
                            <div className="row-form  mt-5  mb-5 num-left">
                                        <h6 class="green-label ">Mobile Number</h6>
                                        <input class="form-controls " type="text" placeholder="" id="example-email-input" maxlength="10"/>
                                        <p class={this.props.msgClass}>{this.props.msg}</p>

                                        </div> 
                                        <div className="text-center ">
                                              <button type="button" class=" add-to-cart2 btnn ">Send OTP</button><br/>
                                              <button type="button" class="  btnn  btn-outline-green">Cancel</button></div>
                            </div>
                </div>
    </div>
    }
}

export default Signup2;
